import React, { useState, useEffect } from 'react';
import Swal from "sweetalert2";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CloseIcon from "@material-ui/icons/Close";
import Resizer from "react-image-file-resizer";


const resizeFile = (file) =>
    new Promise((resolve) => {
        if (file.type === "application/pdf") {
            var fileToLoad = file;
            var fileReader = new FileReader();
            var base64;
            fileReader.onload = async function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                resolve(base64);
            };
            fileReader.readAsDataURL(fileToLoad);
        } else {
            Resizer.imageFileResizer(
                file,
                1500,
                1500,
                "JPEG",
                100,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64"
            );
        }
    });

const BotonCargarArchivo = ({
    doc,
    nombreDocumento,
    idDocumento,
    idTipoDocumentoGD,
    onDocumentoCargado,
    onDocumentoEliminado,
    documentosCargados = []
}) => {
    const [message, setMessage] = useState("");
    const [isUploadFile, setIsUploadFile] = useState(false);

    // Verificar si este documento ya está cargado
    useEffect(() => {
        const documentoCargado = documentosCargados.find(
            doc => doc.nombreDocumento === nombreDocumento
        );
        if (documentoCargado) {
            setIsUploadFile(true);
            setMessage(documentoCargado.fileName || "");
        } else {
            setIsUploadFile(false);
            setMessage("");
        }
    }, [documentosCargados, nombreDocumento]);

    const truncate = (str) => {
        const extension = str.split(".").pop();
        return str.length > 15 ? str.substring(0, 10) + "..." + extension : str;
    };

    const handlerArchivo = async (e) => {
        const files = e.target.files;
        const value = e.target.value;
        let fileConvert;

        if (!files || !files[0]) return;

        // Validar tamaño de archivo (5MB)
        if (files[0].size > 6200000) {
            Swal.fire({
                title: '<strong style="color:#EDEEEF; letter-spacing: 1px;">LO SENTIMOS</strong>',
                icon: "warning",
                html: '<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3">Archivo excede límite de 5MB</font></p>',
                background: "#1E4775",
                showConfirmButton: false,
                showCloseButton: true,
            });
            e.target.value = "";
            return;
        }

        // Validar extensión de archivo
        const allowedExtensions = /(jpg|jpeg|png|gif|pdf)$/i;
        const fileName = value.split("\\").pop();
        const extension = fileName.split(".").pop();

        if (!allowedExtensions.exec(extension)) {
            Swal.fire({
                title: '<strong style="color:#EDEEEF; letter-spacing: 1px;">LO SENTIMOS</strong>',
                icon: "warning",
                html: '<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3">Tipo de archivo no admitido</font></p>',
                background: "#1E4775",
                showConfirmButton: false,
                showCloseButton: true,
            });
            e.target.value = "";
            return;
        }

        try {
            // Convertir archivo
            fileConvert = await resizeFile(files[0]);
            
            // Actualizar estado local
            setMessage(truncate(fileName));
            setIsUploadFile(true);

            // Notificar al componente padre
            if (onDocumentoCargado) {
                onDocumentoCargado(nombreDocumento, {
                    IdTipoDocumentoGD: idTipoDocumentoGD,
                    IdDocumentoUnidad: idDocumento,
                    NombreDocumentoPendiente: nombreDocumento,
                    Documento: fileConvert,
                    IdEstadoDocumento: 3,
                    Activo: false,
                    fileName: fileName,
                    fileSize: files[0].size,
                    fileType: files[0].type
                });
            }
        } catch (error) {
            console.error("Error al procesar archivo:", error);
            Swal.fire({
                title: "Error",
                text: "Hubo un problema al procesar el archivo",
                icon: "error",
                confirmButtonText: "Entendido"
            });
            e.target.value = "";
        }
    };

    const eliminarDocumento = () => {
        setIsUploadFile(false);
        setMessage("");
        
        // Limpiar input file
        const fileInput = document.getElementById(idDocumento);
        if (fileInput) {
            fileInput.value = "";
        }

        // Notificar al componente padre
        if (onDocumentoEliminado) {
            onDocumentoEliminado(nombreDocumento);
        }
    };

    return !isUploadFile ? (
        <div>
            <input
                accept="image/*, application/pdf"
                className="icondocumento"
                type="file"
                id={idDocumento}
                name={idTipoDocumentoGD}
                data-nombredoc={nombreDocumento}
                onChange={handlerArchivo}
            />
            <label
                htmlFor={idDocumento}
                className="button"
            >
                <span>{nombreDocumento === 'CARTA COMPROMISO' ? 'DECLARACIÓN JURADA' : nombreDocumento}</span>
                <CloudUploadIcon />
                <span>{message}</span>
            </label>
        </div>
    ) : (
        <div>
            <label
                className="button loaded"
                onClick={eliminarDocumento}
            >
                <span>{nombreDocumento}</span>
                <CloseIcon className="text-danger" />
                <span>{message}</span>
            </label>
        </div>
    );
};

export default BotonCargarArchivo;